// extracted by mini-css-extract-plugin
var _1 = "Main-moduleMain__Z4xO0";
export { _1 as "Main" }
